export default "__VITE_ASSET__CWVFtlc3__"